module.exports = __webpack_public_path__ + "img/proceedArrow.f4c29c08.svg";